import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS } from "../actionTypes"

const init={
    isLoading:false,
    isError:false,
    isAuth:false,
    token:''
}
export const reducer=(state=init,{type,payload})=>{
switch(type){
    case LOGIN_REQUEST:{
        return {
            ...state,
            isLoading:true
        }
    }
    case LOGIN_SUCCESS:{
        return{
            ...state,
            isLoading:false,
            isAuth:true,
            token:payload
        }
    }
    case LOGIN_FAILURE:{
        return{
            ...state,
            isLoading:false,
            isError:true
        }
    }
    default:return state
}
}